import { cn } from '@/lib/cn'

export interface EmptyStateProps {
  icon?: React.ComponentType<{ className?: string }>
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

/**
 * Standardized empty state for lists, tables, and data sections.
 * Replaces bare <p> tags for zero-data conditions.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-gray-200 bg-gray-50/50 px-6 py-12 text-center dark:border-gray-700 dark:bg-gray-800/30',
        className
      )}
    >
      {Icon && (
        <div className="rounded-full bg-gray-100 p-3 dark:bg-gray-700/50">
          <Icon className="h-6 w-6 text-gray-400 dark:text-gray-500" aria-hidden />
        </div>
      )}
      <div className="space-y-1">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{title}</p>
        {description && (
          <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
        )}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  )
}

EmptyState.displayName = 'EmptyState'
